module.exports = __webpack_public_path__ + "img/about-main.e5bfa22b.jpg";